(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientPictureDialogController', PatientPictureDialogController);

    PatientPictureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatientPicture'];

    function PatientPictureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatientPicture) {
        var vm = this;

        vm.patientPicture = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientPicture.id !== null) {
                PatientPicture.update(vm.patientPicture, onSaveSuccess, onSaveError);
            } else {
                PatientPicture.save(vm.patientPicture, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientPictureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
